import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  alert: {
    marginBottom: theme.spacing(2),
  },
}));

export default useStyles;
